module.exports = __webpack_public_path__ + "assets/a497c13ab09d9934c254e3d67dbca8e4.png";